// Display label for a Feature `type` — the value the API reports for a
// Feature: its habitat classification key (e.g. `swimming_pool`,
// `catch_basin`, `depression`), or `pool` for a Nidus pool detection (a
// Reveal/manual feature_pool) the source never classified. See the backend
// featureType() in platform/feature.go — it replaced a hardcoded "pool" that
// labelled every Feature alike.
//
// The habitat names come from the ontology's own term files (see
// ts/lib/dimensionLabels.ts); this module only owns the one token that is not a
// habitat, `pool`. A token the ontology has not named renders as the raw token,
// so an unnamed Feature reads as unfinished rather than carrying an invented
// name.

import { dimensionValueLabel } from "@/lib/dimensionLabels";

/** Human-readable label for a Feature `type`; "Unknown" when the API states none. */
export function featureTypeLabel(type: string): string {
	if (!type) return "Unknown";
	if (type === "pool") return "Pool";
	return dimensionValueLabel("habitat_class", type);
}
